import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./store/auth/";
import settings from "./store/settings/";
import agGrid from "./store/agGrid";
import users from "./store/users/";
import general from "./store/general/";
import outcomes from "./store/outcomes/";
import questions from "./store/questions/";
import goals from "./store/goals/";
import goalsSolutions from "./store/goalsSolutions/";
import actions from "./store/actions/";
import solutions from "./store/solutions/";
import sources from "./store/sources/";
import datatypes from "./store/datatypes/";
import units from "./store/units/";
import articles from "./store/articles/";
import keywords from "./store/keywords";
import basicGoals from "./store/basicGoals";
import customSourcesBusinessTotal from "./store/customSourcesBusinessTotal";
import businessStarSources from "./store/businessStarSources";
import outcomePlanQuestionnaire from "./store/outcomePlanQuestionnaire";
import businessAnswers from "./store/businessAnswers";
import businessFindEntriesLikes from "./store/businessFindEntriesLikes";
import mailing from "./store/mailing";
import businessOutcomePlans from "./store/businessOutcomePlans";
import pageHelp from "./store/pageHelp";
import actionTemplates from "./store/actionTemplates";
import reports from "./store/reports";
import storyCard from "./store/storyCard";
import fullPlan from "./store/fullPlan";
import businessExtra from "./store/businessExtra";
import businessTargets from "./store/businessTargets";
import business from "./store/business";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    settings,
    agGrid,
    users,
    general,
    outcomes,
    questions,
    goals,
    goalsSolutions,
    actions,
    solutions,
    sources,
    datatypes,
    units,
    articles,
    keywords,
    basicGoals,
    customSourcesBusinessTotal,
    businessStarSources,
    outcomePlanQuestionnaire,
    businessAnswers,
    businessFindEntriesLikes,
    mailing,
    businessOutcomePlans,
    pageHelp,
    actionTemplates,
    reports,
    storyCard,
    fullPlan,
    businessExtra,
    businessTargets,
    business
  },
  plugins: [
    createPersistedState({
      paths: ["auth", "settings"],
    }),
  ],
});
